import moment from "moment";

const monthsInSeries = 12;

// Builds a fixed calendar-month series ending at `now` (oldest first) for the
// completed-by-month bar chart. The API omits months with no completions, so any
// month missing from `completedByMonth` defaults to a zero count.
export function buildCompletedByMonthSeries(completedByMonth, now) {
    const windowStart = moment(now).startOf("month").subtract(monthsInSeries - 1, "months");
    const series = [];

    for (let monthIndex = 0; monthIndex < monthsInSeries; monthIndex++) {
        const monthStart = windowStart.clone().add(monthIndex, "months");

        const matchingEntry = (completedByMonth ?? []).find(
            (entry) => entry.year === monthStart.year() && entry.month === monthStart.month() + 1
        );

        series.push({
            year: monthStart.year(),
            month: monthStart.month() + 1,
            label: monthStart.format("MMM"),
            count: matchingEntry?.count ?? 0
        });
    }

    return series;
}
